import React from 'react';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { getStyles } from './badge-styles';

export const BadgeUnstyled = (props) => {
  const {
    text, secondaryText, className, classes,
  } = props;
  return (
    <div className={classNames(classes.badgeContainer, className)}>
      <div className={classNames(classes.primaryText, 'badge-primary-text')}>
        {text}
      </div>
      <div className={classNames(classes.secondaryText, 'badge-secondary-text')}>
        {secondaryText}
      </div>
    </div>
  );
};

BadgeUnstyled.propTypes = {
  text: PropTypes.string.isRequired,
  secondaryText: PropTypes.string,
  className: PropTypes.string,
  classes: PropTypes.shape({
    badgeContainer: PropTypes.string.isRequired,
  }),
};

BadgeUnstyled.defaultProps = {
  classes: null,
  secondaryText: null,
  className: null,
};

export const Badge = withDefaultStyles(
  BadgeUnstyled,
  getStyles
);
